/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 *
 */

let baseUrl = '';
let httpUrl = "" ; //用户中心
let beadhouseUrl = "" ;

if (process.env.NODE_ENV == 'development') {

    baseUrl = 'https://zpdcare6.njch.com.cn';

}else if(process.env.NODE_ENV == 'production'){
  
    baseUrl = 'https://zpdcare6.njch.com.cn';
}

export {
    baseUrl,
    httpUrl,
    beadhouseUrl
}

